import { connect } from 'react-redux';

import { FiltersDesktop, IFiltersDesktopProps } from '../../components/FiltersDesktop';
import { IApplicationState, TThunkDispatch } from '../../types/redux';
import { EDealType } from '../../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';
import { setDealType, setFavoriteEntityType } from '../../actions/filters';
import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { setShowFiltersModal } from '../../actions/filters/filters_modal';
import { EEntityType } from '../../types/filters';
import { unselectAll } from '../../actions/selected';

type TFiltersStateDesktopProps = Pick<IFiltersDesktopProps, 'filters' | 'results'>;
type TFiltersDispatchProps = Pick<
  IFiltersDesktopProps,
  'setDealType' | 'setFavoriteEntityType' | 'getFavoriteEntities' | 'setShowFiltersModal'
>;

function mapStateToProps(state: IApplicationState): TFiltersStateDesktopProps {
  return {
    filters: state.filters,
    results: state.results,
  };
}

function mapDispatchToProps(dispatch: TThunkDispatch): TFiltersDispatchProps {
  return {
    setDealType: (dealType: EDealType | null) => {
      dispatch(unselectAll());
      dispatch(setDealType(dealType));
    },
    setFavoriteEntityType: (favoriteEntityType: EEntityType | null) => {
      return dispatch(setFavoriteEntityType(favoriteEntityType));
    },
    getFavoriteEntities: () => {
      return dispatch(fetchFavoriteEntities({ offset: 0 }));
    },
    setShowFiltersModal: (showFiltersModal: boolean) => dispatch(setShowFiltersModal(showFiltersModal)),
  };
}

export const FiltersDesktopContainer = connect(mapStateToProps, mapDispatchToProps)(FiltersDesktop);
